import axios from "axios"
import { API_HOST } from "../BaseUrl"
import client, { headers } from "./config"
import { encrypt, generateHMAC } from "../../Utils/hmac"

export const imageUpload = async ({ formData }) => {
    const hmac = await generateHMAC()
    
    // Add client data from localStorage to formData
    let company;
    try {
        const companyData = localStorage.getItem("company");
        company = companyData ? JSON.parse(companyData) : {};
    } catch (e) {
        // If parsing fails, treat as plain string
        company = localStorage.getItem("company") || "";
    }
    
    // console.log("Adding client data to formData:", company);
    formData.append('client', JSON.stringify(company));
    
 
    
    const updatedHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data',
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `ai/image/analysis`, formData, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response.data)
        } catch (error) {
            reject(error)
        }
    })
}

export const submitScan = async (data) => {
    const hmac = await generateHMAC()
    const _n = encrypt(data)
    const updatedHeader = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.post(API_HOST + `ai/folder/analyze`, { _n }, { headers: updatedHeader })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const deleteReshootImagesS3 = async (formData) => {
    const hmac = await generateHMAC();

    const fileOnlyFormData = new FormData();

    // Copy raw file fields and _n only
    for (let [key, value] of formData.entries()) {
        if (["aadhaarFront", "aadhaarBack", "panCard", "_n"].includes(key)) {
            fileOnlyFormData.append(key, value);
        }
    }

    const updatedHeader = {
        ...headers,
        "Content-Type": "multipart/form-data",
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };

    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.post(API_HOST + `delete/reshoot-images-s3`, fileOnlyFormData, {
                headers: updatedHeader,
            });
            if (response.status === 200) resolve(response);
            else reject(response);
        } catch (error) {
            reject(error);
        }
    });
};

export const updateInsuranceReshootDetails = async (formData) => {
    const hmac = await generateHMAC();

    const fileOnlyFormData = new FormData();

    for (let [key, value] of formData.entries()) {
        if (["aadhaarFront", "aadhaarBack", "panCard", "_n"].includes(key)) {
            fileOnlyFormData.append(key, value);
        }
    }

    const updatedHeader = {
        ...headers,
        "Content-Type": "multipart/form-data",
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };

    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.post(API_HOST + `update-reshoot-details`, fileOnlyFormData, {
                headers: updatedHeader,
            });
            if (response.status === 200) resolve(response);
            else reject(response);
        } catch (error) {
            reject(error);
        }
    });
};


const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });


export const createScan = async (data) => {
    const hmac = await generateHMAC()
    const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `tp-report/store`, { _n }, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        }
        catch (error) {
            reject(error)
        }


    });


}

export const getTpStatus = async ({ uid, c }) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.get(API_HOST + `tp-uid-status/${uid}`, {
                headers: updatedHeaders,
                params: { c }
            })
            if (response.status === 200) {
                resolve(response);
            }
            reject(response);

        } catch (error) {
            reject(error)
        }

    });
};

export const checkScanIdStatus = async ({ verification_id }) => {
    const encodedId = encodeURIComponent(verification_id);
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.get(API_HOST + `tpscan/validate-id/${encodedId}`, { headers: updatedHeaders });
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)

        }
    })
}

export const notifyCameraError = async (data) => {
    const hmac = await generateHMAC()
    const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + "selfie/camera-failed", { _n }, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}


export const uploadFace = async ({ formData }) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "Content-Type": "multipart/form-data",
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `tpscan/face-upload`, formData, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}


export const createStarInsuranceScan = async (data) => {
    const hmac = await generateHMAC()
    const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `tl-star/store`, { _n }, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const savePatientKycDetails = async (data) => {
    const hmac = await generateHMAC()
    // const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `patient-details`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}